import React from 'react';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import Spinner from '../../Spinner';
import { SpinnerContainer } from './styles';

const InputSpinner: React.FC<ComponentProps> = ({ ...rest }) => {
  return (
    <SpinnerContainer {...componentProps(rest)}>
      <Spinner aria-label="Loading" />
    </SpinnerContainer>
  );
};

export default applyComponentTheme(InputSpinner, 'InputSpinner');
